import React, { forwardRef } from "react";

import AddBox from "@material-ui/icons/AddBox";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import styled from "styled-components";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => (
    <FirstPage
      // style={{
      //   fill: "#293461",
      //   width: "35px",
      //   height: "26.5px",
      //   borderRadius: "4px",
      //   border: "solid 0.5px #bbbbbb",
      //   backgroundColor: "#f9f9f9",
      //   justifyContent: "center",
      //   alignItems: "center",
      // }}
      {...props}
      ref={ref}
    />
  )),
  LastPage: forwardRef((props, ref) => (
    <LastPage
      // style={{
      //   fill: "#293461",
      //   width: "35px",
      //   height: "26.5px",
      //   borderRadius: "4px",
      //   border: "solid 0.5px #bbbbbb",
      //   backgroundColor: "#f9f9f9",
      //   justifyContent: "center",
      //   alignItems: "center",
      // }}
      {...props}
      ref={ref}
    />
  )),
  NextPage: forwardRef((props, ref) => (
    <ChevronRight
      // style={{
      //   fill: "#293461",
      //   width: "35px",
      //   height: "26.5px",
      //   borderRadius: "4px",
      //   border: "solid 0.5px #bbbbbb",
      //   backgroundColor: "#f9f9f9",
      //   justifyContent: "center",
      //   alignItems: "center",
      // }}
      {...props}
      ref={ref}
    />
  )),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft
      // style={{
      //   fill: "#293461",
      //   width: "35px",
      //   height: "26.5px",
      //   borderRadius: "4px",
      //   border: "solid 0.5px #bbbbbb",
      //   backgroundColor: "#f9f9f9",
      //   justifyContent: "center",
      //   alignItems: "center",
      // }}
      {...props}
      ref={ref}
    />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => (
    <Search style={{ marginLeft: "5px" }} {...props} ref={ref} />
  )),
  SortArrow: forwardRef((props, ref) => (
    <SortIcon
      src={require("../../../../assets/images/sortIcon.svg")}
      {...props}
      ref={ref}
    />
  )),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

export default tableIcons;

const SortIcon = styled.img`
  width: 8px;
  height: 8px;
  margin-left: 9px;
  object-fit: contain;
  cursor: pointer;
`;
